const LAST_SPOT_SLUG_KEY = 'last_spot_slug'

export function getLastSpotSlug(): string | null {
  try {
    return localStorage.getItem(LAST_SPOT_SLUG_KEY)
  } catch {
    return null
  }
}

export function setLastSpotSlug(slug: string): void {
  try {
    localStorage.setItem(LAST_SPOT_SLUG_KEY, slug)
  } catch {
    // Storage unavailable (private mode): the landing stays the entry page.
  }
}
